import { gql } from '@apollo/client';

export const ARTICLE_FRAGMENT = gql`
  fragment article on Article {
    urls(first: 1, orderBy: order_ASC) {
      origin
      path
    }
    authors(first: 10) {
      order
      author {
        id
        name
        user {
          id
          name
          avatarUrl
        }
      }
    }
    categories(first: 2, orderBy: order_ASC) {
      order
      category {
        id
        title
      }
    }
    channels(first: 1) {
      order
      category {
        id
        title
      }
    }
    creator {
      name
    }
    events(first: 2) {
      category {
        id
        title
      }
    }
    qualifiers(first: 100) {
      qualifier {
        title
      }
    }
    body
    brandKey
    editedAt
    format
    id
    live {
      postCount
    }
    medias
    publishedAt
    pushCount
    secondaryTitle
    status
    title
    partnerTitle
    lead
  }
`;
